import { render, staticRenderFns } from "./role_modal.vue?vue&type=template&id=24d73830&scoped=true&"
import script from "./role_modal.vue?vue&type=script&lang=js&"
export * from "./role_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d73830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d73830')) {
      api.createRecord('24d73830', component.options)
    } else {
      api.reload('24d73830', component.options)
    }
    module.hot.accept("./role_modal.vue?vue&type=template&id=24d73830&scoped=true&", function () {
      api.rerender('24d73830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/role_modal.vue"
export default component.exports